/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon, Button } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import AppStorage from '@Services/AppStorage';
import { dispatchOpenSaveFormModal } from '@Containers/SaveFormModal/SaveFormModalActions';
import { useDispatch, useSelector } from 'react-redux';
import * as ControlsHelper from './ControlsHelper';
import { resetNodeValueAction, resetSearchBuilderAction, addToBuilderAction, getFormsAction } from '../QueryletActions';
import FlyoutContent from '../Shared/FlyoutContent';
import { SAVE_OPTIONS, BUTTON_CONFIG } from './constants';
import './Controls.custom.scss';
import { forms } from '../QuerySelector';

function Controls({ nodesList, properties, favList, hiddenList, importedQuery, importedQueryStateParamValue }) {
  const dispatch = useDispatch();
  const formsList = useSelector(forms);
  const [isOpen, setIsOpen] = useState(false);
  const buttonConfig = BUTTON_CONFIG(nodesList);
  const saveOptions = SAVE_OPTIONS;

  const toggleIsOpen = () => {
    setIsOpen((_isOpen) => !_isOpen);
  };

  useEffect(() => {
    if ((importedQuery || importedQueryStateParamValue) && properties && properties.length) {
      const importedQueryData = importedQueryStateParamValue || importedQuery;
      ControlsHelper.importer(nodesList, properties, importedQueryData.queryFactItem || importedQueryData, {
        context: importedQueryData.context,
        ...(importedQueryData.resolvedByCasApi && { resolvedByCasApi: importedQueryData.resolvedByCasApi }),
      });
    }
  }, [importedQuery, importedQueryStateParamValue, properties]);

  function updatebasedonIcon(label) {
    switch (label) {
      case 'redo':
        return dispatch(resetNodeValueAction(nodesList));
      case 'trash':
        return dispatch(resetSearchBuilderAction(nodesList, properties, hiddenList));
      case 'saveFile':
        return toggleIsOpen();
      default:
        return ControlsHelper.importQuery();
    }
  }

  function openSaveFormModal() {
    dispatchOpenSaveFormModal({
      forms:
        formsList.filter((form) => form.displayName === 'My Forms')[0] &&
        formsList.filter((form) => form.displayName === 'My Forms')[0].children,
      refreshForms: () => {
        dispatch(getFormsAction());
      },
    });
  }

  const onSaveChange = ({ id }) => {
    AppStorage.instance.set('qbNodesList', nodesList);
    if (id.toLowerCase() === 'savequery') {
      ControlsHelper.saveToFile('name', nodesList);
    } else {
      openSaveFormModal();
    }
  };
  return (
    <div className="qb-control-container u-els-margin-top-5x" role="navigation" aria-label="Query Builder Tools">
      <div className="qb-control-container__left_container">
        {buttonConfig.map((config) =>
          config.dropdown && !config.disabled ? (
            <Flyout
              key={config.id}
              flyout={<FlyoutContent options={saveOptions} key={config.id} onSaveChange={onSaveChange} setIsOpen={setIsOpen} />}
              shouldCloseOnESC
              isOpen={isOpen}>
              <ButtonWithIcon
                type="link"
                layout="vertical"
                sprite={config.label}
                data-automationId={config.automationId}
                id={config.id}
                disabled={config.disabled}
                onClick={() => updatebasedonIcon(config.id)}>
                {config.ally.name}
              </ButtonWithIcon>
            </Flyout>
          ) : (
            <ButtonWithIcon
              key={config.id}
              type="link"
              id={config.id}
              data-automationId={config.automationId}
              layout="vertical"
              sprite={config.label}
              onClick={() => updatebasedonIcon(config.id)}
              disabled={config.disabled}>
              {config.ally.name}
            </ButtonWithIcon>
          )
        )}
      </div>
      <div className="qb-control-container__right_container">
        {favList.map((config) =>
          config.label !== 'Pixel' ? (
            <Flyout
              key={config.id}
              flyout={config.fullName ? config.fullName : config.shortName}
              shouldCloseOnESC
              theme="simple"
              trigger="hover">
              <ButtonWithIcon
                key={config.id}
                type="link"
                id={config.id}
                layout="vertical"
                data-automationId={config.automationId}
                sprite={config.label}
                aria-label={config.shortName}
                onClick={() => dispatch(addToBuilderAction(config, 'default'))}
                disabled={config.hidden}>
                {config.shortName}
              </ButtonWithIcon>
            </Flyout>
          ) : (
            <Flyout
              key={config.id}
              flyout={config.fullName ? config.fullName : config.shortName}
              shouldCloseOnESC
              theme="simple"
              trigger="hover">
              <Button
                key={config.id}
                type="link"
                id={config.id}
                data-automationId={config.automationId}
                layout="vertical"
                className="c-els-link--with-icon c-els-link-vertical-temp"
                onClick={() => dispatch(addToBuilderAction(config, 'default'))}
                disabled={config.hidden}>
                <span className="c-els-link__icon icon__wrapper">
                  <svg
                    viewBox="0 0 104 128"
                    aria-hidden="true"
                    focusable="false"
                    className="icon o-els-icon-svg o-els-icon-svg--1x1o2 o-els-icon-svg--middle o-els-icon-svg--font-offset"
                    role="img">
                    <use xlinkHref={config.iconId} />
                  </svg>
                </span>
                <span className="c-els-button__text c-els-link__text">{config.shortName}</span>
              </Button>
            </Flyout>
          )
        )}
      </div>
    </div>
  );
}
Controls.propTypes = {
  nodesList: PropTypes.array,
  properties: PropTypes.array,
  hiddenList: PropTypes.array,
  importedQuery: PropTypes.any,
  importedQueryStateParamValue: PropTypes.any,
  favList: PropTypes.array,
};
export default Controls;
